import { api } from "../helpers/apiHelperV3";
import { urls } from "./urls";
//
const OPEN_ORDER = urls.cashier.API_NUVEI("openOrder");
const GET_PAYMENT_STATUS = urls.cashier.API_NUVEI("processDeposit");
const GET_PROCESS_WITHDRAWAL = urls.cashier.API_NUVEI("processWithdrawal");
const GET_PROCESS_DEPOSIT_ERROR = urls.cashier.API_NUVEI("processDepositError");
const GET_PROCESS_WITHDRAWAL_ERROR = urls.cashier.API_NUVEI(
  "processWithdrawalError"
);

/**
 * get session-token for transaction from Nuvei
 */
export const openOrder = (
  amount: string,
  paymentType: string,
  currency: string,
  openOrderPaymentMethod: string
) => {
  const url = OPEN_ORDER;
  const data = {
    amount: amount,
    currencyShortCode: currency,
    paymentType: paymentType,
    paymentMethod: openOrderPaymentMethod,
  };

  return api.post(url, data);
};

/**
 * verify payment status
 */
export const processDeposit = (sessionToken: string) => {
  const url = GET_PAYMENT_STATUS;
  const data = {
    sessionToken: sessionToken,
  };

  return api.post(url, data);
};

/**
 * process withdrawal request
 */
export const processWithdrawal = (
  wdRequestId: string,
  paymentAttemptId: number
) => {
  const url = GET_PROCESS_WITHDRAWAL;
  const data = {
    wdRequestId: wdRequestId,
    paymentAttemptId: paymentAttemptId,
  };

  return api.post(url, data);
};

/**
 * process deposit errors and log to graylog request
 */
export const processDepositError = (error: string, clientUniqueId: number) => {
  const url = GET_PROCESS_DEPOSIT_ERROR;
  const data = {
    message: error,
    clientUniqueId: clientUniqueId,
  };

  return api.post(url, data);
};

/**
 * process withdrawal errors and log to graylog request
 */
export const processWithdrawalError = (
  error: string,
  clientUniqueId: number
) => {
  const url = GET_PROCESS_WITHDRAWAL_ERROR;
  const data = {
    message: error,
    clientUniqueId: clientUniqueId,
  };

  return api.post(url, data);
};
